export const STEP = {
  FILL_MARKING: 'FILL_MARKING',
  FILL_IMEIS: 'FILL_IMEIS',
  SELL_TO_ALIF: 'SELL_TO_ALIF',
  COMPLETION: 'COMPLETION',
  SEND_FOR_DELIVERY: 'SEND_FOR_DELIVERY',
};
